module.exports = __webpack_public_path__ + "img/ewe-go-ic.9a9b02cf.webp";